import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProjectService} from "../../services/project/project.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Project} from "../../models/project";
import {ProjectModal} from "../../modals/project-modal/project-modal.component";
import {MessagesService} from "../../services/messages/messages.service";
import {AuthService} from "../../services/auth/auth.service";

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent implements OnInit {

  @Input() projectId: string;
  @Output() selectedProjectId: EventEmitter<string> = new EventEmitter<string>();

  projects: Array<Project>;
  userIsAdmin = false;

  constructor(
    private modalService: NgbModal,
    private projectService: ProjectService,
    private authService: AuthService,
    private messagesService: MessagesService,
  ) {
  }

  ngOnInit() {
    this.userIsAdmin = this.authService.isAdmin();

    this.projectService.getAllMyProjects()
      .subscribe(
        () => {
          this.projects = this.projectService.projects;
        },
        e => console.log(e));
  }

  onShowModal(project: Project = null) {
    let modalRef;

    modalRef = this.modalService.open(ProjectModal, {size: 'lg'});
    modalRef.componentInstance.project = project;

  }

  onSelect(projectId: string) {
    this.projectId = projectId;
    this.selectedProjectId.emit(projectId);
  }

  onDelete(id) {
    this.messagesService.confirmModal().result.then(
      result => {
        if (result)
          this.projectService.deleteProject(id).subscribe(
            () => this.messagesService.successToast('Location deleted.'),
            err => this.messagesService.errorToast(err));
      }
    ).catch(() => {
    });
  }

  onExportCsv(id) {
    this.projectService.exportProjectCsv(id).subscribe(
      () => {},
      err => this.messagesService.errorToast('Could not generate export!'));
  }
}
